import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Role } from "../../model/user/role.model";
import { GenericApi } from "../generic.api";

// Convenience Type
type T = Role;
type I = Role;

@Injectable({
  providedIn: "root",
})
export class RoleApi extends GenericApi<T> {
  public path = "role";

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }
}
